export function sendEmail(){
    return {
        "success": true,
        "message": "OK",
        "data": null
    }
}